import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Link, Stack } from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Form } from './Form'
import { FormTitle } from '../components'
import { useTranslations } from './useTranslations'

export const LoginPage = () => {
  const { forgotPassword } = useTranslations()

  return <>
    <FormTitle id="loginTitle">Sign In</FormTitle>

    <Form />

    <Stack direction='row' justifyContent='space-between' alignItems='center' mt='1rem'>
      <Link variant='body1' lineHeight={1.25}
        id="goHome" title="Back to home"
        component={RouterLink} to="/"
      >
        <Box component={FontAwesomeIcon} icon={faArrowLeft} display='inline' mr={1} />
        Go back
      </Link>
      <Link variant='body1' lineHeight={1.25}
        id="forgotPassword" title="Reset your password"
        component={RouterLink} to="/forgot"
      >
        {forgotPassword}?
      </Link>
    </Stack>
  </>
}